var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 13C5.23857 13 3 10.7614 3 8C3 5.23857 5.23857 3 8 3C10.7614 3 13 5.23857 13 8C13 10.7614 10.7614 13 8 13ZM6.38889 6.72223C6.38889 6.53813 6.53813 6.38889 6.72223 6.38889H9.27777C9.46187 6.38889 9.61111 6.53813 9.61111 6.72223V9.27777C9.61111 9.46187 9.46187 9.61111 9.27777 9.61111H6.72223C6.53813 9.61111 6.38889 9.46187 6.38889 9.27777V6.72223Z",
    fill: "#3C64EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMeta);
export default __webpack_public_path__ + "static/media/circle_meta.b3a421249ecb64d46029b08b52c16136.svg";
export { ForwardRef as ReactComponent };